import React from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import LogoPng from '../../assests/images/logo.png';
import FinxPayPng from '../../assests/images/finxpay.png';
import './Logo.css';
class LeftMenuLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
        }
    }


    componentDidMount() { }
    componentWillUnmount() {
    }




    render() {
        console.log('Inside render');
        return (

            <div class="logo">
                <Link to="/dashboard">
                    <img src={LogoPng} alt="FinXpay" class="d-none d-md-block" />
                    <img src={FinxPayPng} alt="FinXpay" class="d-block d-md-none" />
                </Link>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(LeftMenuLogo);
